import { render, staticRenderFns } from "./LoaLevelDescriptions.vue?vue&type=template&id=5f3f5473"
import script from "./LoaLevelDescriptions.vue?vue&type=script&lang=js"
export * from "./LoaLevelDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports